(ns frontend.ui.component.layout.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))


(defn items-group
  []
  {:padding "16px"})

(defn items-group-heading
  []
  {:padding        "0 0 20px"
   :letter-spacing "0.1px"
   :font-weight    "bold"
   :color          (theme/color [:text :primary :color])})

(defn list-item
  []
  {:padding "12px 0"})

(defn row
  []
  {:display         "flex"
   :margin          "-16px"
   :flex-direction  "row"
   :justify-content "stretch"
   :flex            "1 1 auto"})

(defn row-align-left
  []
  {:display        "flex"
   :flex-direction "row"
   :justify-content "start"
   :flex           "1 1 auto"})

(defn col-left
  []
  ^{:media {{:screen :only :max-width :991px}
            {:padding "16px"}}}
  {:display         "flex"
   :padding         "32px"
   :flex-direction  "column"
   :justify-content "start"
   :flex            "0 0  auto"
   :background      (theme/color [:page-bg :bg])
   :border-right    (space-join ["1px" "solid" (theme/color [:layout :col :right-border])])
  })

(defn col-right
  []
  ^{:media {{:screen :only :max-width :991px}
            {:padding "16px"}}}
  {:display        "flex"
   :padding        "32px"
   :flex-direction "column"
   :flex           "1 1 auto"})
